.group {
  position: relative;
  display: inline-flex;
  flex: none;
  padding: 4px;
  border-radius: 999px;
  background: var(--bar-bg);
  border: 1px solid var(--bar-line);
  box-shadow: inset 0 1px 0 rgb(255 255 255 / 0.1);
}

.pill {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 0;
  right: 0;
  border-radius: 999px;
  background: color-mix(in srgb, var(--fill) 26%, transparent);
  border: 1px solid color-mix(in srgb, var(--fill-soft) 60%, transparent);
  box-shadow: 0 0 18px var(--card-glow);
  pointer-events: none;
  opacity: 0;
}

.option {
  position: relative;
  z-index: 1;
  width: 40px;
  height: 32px;
  border: 0;
  border-radius: 999px;
  padding: 0;
  display: grid;
  place-items: center;
  background: transparent;
  color: var(--muted);
  transition:
    color 0.25s ease,
    transform 0.2s ease;
}

.option:hover {
  filter: none;
  color: var(--text);
}

.option[aria-checked='true'] {
  color: var(--accent);
}

.option:active {
  transform: scale(0.92);
}

.option:focus-visible {
  outline: 2px solid var(--accent-soft);
  outline-offset: 1px;
}

@media (prefers-reduced-motion: reduce) {
  .option {
    transition: none;
  }
}
